export default __webpack_public_path__ + "static/media/barchart.86d11fdf.svg";